export const REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_ACTIONS_HEADER_ICON_BAR_BREAKPOINTS =
  [
    { maxVisibleIcons: 5, minWidth: 800 },
    { maxVisibleIcons: 4, minWidth: 700 },
    { maxVisibleIcons: 3, minWidth: 600 },
    { maxVisibleIcons: 2, minWidth: 0 },
  ]
